import * as req from 'api/actions';
import * as c from './constants';

export const getSettings = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_SETTINGS,
    'api/v1/administrators/billing_import',
    payload,
    callback
  );

export const dummy = () => {};
